import { Action, ActionCreator } from 'redux';
import { Comment } from './comment';
import { CommentsInterface } from './comments.interface';

export const CLEARCOMMENTS = 'CLEARCOMMENTS';
export interface ClearAction extends Action {
    comments: CommentsInterface;
}

// 拉黑、取消拉黑
export const FILTERCOMMENTS = 'FILTERCOMMENTS';
export const UNFILTERCOMMENTS = 'UNFILTERCOMMENTS';

export const SETCOMMENTREPORTED = 'SETCOMMENTREPORTED';

export interface FilterAction extends Action {
    userId: string
}
export const clear: ActionCreator<ClearAction> =
    (comments) => ({
        type: CLEARCOMMENTS,
        comments: comments
    });

export const APPEND = 'APPEND';
export interface AppendAction extends Action {
    comments: CommentsInterface;
}


export const APPENDTOPARENT = 'APPENDTOPARENT';
export interface AppendToParentAction extends Action {
    comments: CommentsInterface;
}


export const append: ActionCreator<AppendAction> =
    (comments) => ({
        type: APPEND,
        comments: comments
    });

export const INSERT = 'INSERT';
export interface InsertAction extends Action {
    comments: CommentsInterface;
}

export const insert: ActionCreator<InsertAction> =
    (comments) => ({
        type: APPEND,
        comments: comments
    });
